const c = {
  name: "LocalPaymentMethods",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3.1,9.3C6.7,3.7,12.9,0,20,0c2.5,0,4.9,0.5,7.1,1.3C27.8,0.5,28.9,0,30,0c2.2,0,4,1.8,4,4
			c0,0.5-0.1,1-0.3,1.5c2.4,2.3,4.3,5.2,5.3,8.5c0.6,1.9,0.9,4,0.9,6.1c0,5.7-2.4,10.9-6.3,14.5c0.2,0.5,0.3,1,0.3,1.5
			c0,2.2-1.8,4-4,4c-1.1,0-2.2-0.5-2.9-1.3C24.9,39.5,22.5,40,20,40c-3.3,0-6.5-0.8-9.3-2.3c-3.9-2-7-5.3-8.9-9.4
			C0.7,25.8,0,23,0,20C0,16.1,1.1,12.4,3.1,9.3z M30.2,8c-0.1,0-0.1,0-0.2,0c-0.8,0-1.5-0.2-2.2-0.6c-0.4-0.2-0.7-0.5-1-0.9
			l-10.9,4.9c0,0.2,0,0.4,0.1,0.5c0,0,0,0.1,0,0.1c0,0.3,0,0.7-0.1,1l4.2,2.3c0.7-0.8,1.8-1.3,2.9-1.3c1.5,0,2.8,0.8,3.5,2.1
			l10.3-2.6c-0.9-2.5-2.4-4.6-4.3-6.4C31.9,7.6,31.1,7.9,30.2,8z M27,18c0,2.2-1.8,4-4,4c-0.5,0-1.1-0.1-1.5-0.3l-1.4,1.8
			c0.5,0.7,0.9,1.6,0.9,2.5v0c0,0.5-0.1,1.1-0.3,1.6l6.9,5.3c0.7-0.5,1.6-0.8,2.5-0.8c0.6,0,1.2,0.1,1.7,0.4
			c0.3,0.1,0.6,0.3,0.8,0.5C35.9,29.6,38,25.1,38,20c0-1.6-0.2-3.1-0.6-4.6L27,18z M14.9,14.7c-0.2,0.2-0.4,0.4-0.7,0.6l2.4,6.7
			c0.1,0,0.2,0,0.4,0c0.5,0,1.1,0.1,1.5,0.3l1.4-1.8C19.3,19.8,19,19,19,18.2c0-0.1,0-0.1,0-0.2c0-0.3,0-0.7,0.1-1L14.9,14.7z
			 M12.4,16c-0.1,0-0.2,0-0.4,0c-2.2,0-4-1.8-4-4c0,0,0,0,0-0.1l-3.6-1C2.9,13.6,2,16.7,2,20c0,2.4,0.5,4.7,1.4,6.8l9.7-1.3
			c0.1-1.2,0.8-2.2,1.7-2.8L12.4,16z M13.3,27.5l-9,1.2c1.5,2.8,3.8,5.1,6.5,6.7l3.5-6.5c-0.4-0.3-0.7-0.7-0.9-1.2
			C13.4,27.7,13.3,27.6,13.3,27.5z M5.6,9.2L8.5,10c0.7-1.2,2-2,3.5-2c0.8,0,1.5,0.2,2.2,0.6c0.4,0.2,0.7,0.5,1,0.9l10.9-4.9
			c0-0.2,0-0.4-0.1-0.5c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.3,0-0.6,0.1-0.9C24.2,2.4,22.1,2,20,2C14.1,2,8.9,4.8,5.6,9.2z M20,38
			c2.1,0,4.2-0.4,6.1-1.1l0,0C26,36.6,26,36.3,26,36c0-0.3,0-0.6,0.1-0.9c0.1-0.2,0.1-0.4,0.2-0.6l-6.9-5.3C18.8,29.7,17.9,30,17,30
			v0c0,0-0.1,0-0.1,0c-0.3,0-0.6,0-0.8-0.1l-3.5,6.5C14.8,37.4,17.3,38,20,38z M31.8,5C31.9,4.7,32,4.3,32,4c0-1.1-0.9-2-2-2
			c-0.7,0-1.4,0.4-1.7,1c-0.1,0.2-0.2,0.3-0.2,0.5C28,3.6,28,3.8,28,3.9c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.4,0.2,0.6
			C28.5,5.5,29.2,6,30,6c0.4,0,0.8-0.1,1.1-0.4c0.2-0.1,0.4-0.3,0.5-0.5L31.8,5z M31.7,34.9c-0.3-0.5-0.8-0.8-1.4-0.9
			c-0.1,0-0.2,0-0.2,0c-0.6,0-1.1,0.2-1.5,0.6c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.2-0.2,0.5-0.2,0.8
			c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.3,0.1,0.7,0.3,0.9l0,0.1c0.4,0.6,1,0.9,1.7,0.9c1.1,0,2-0.9,2-2C32,35.6,31.9,35.3,31.7,34.9
			L31.7,34.9z M12,14c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3-0.1l0,0l0,0c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.4-0.3,0.6-0.5
			c0.1-0.1,0.2-0.2,0.3-0.4c0.2-0.3,0.2-0.6,0.2-1c0,0,0-0.1,0-0.1c0-0.2-0.1-0.5-0.2-0.7c-0.3-0.7-1-1.2-1.8-1.2
			c-0.9,0-1.7,0.6-1.9,1.5c0,0.2-0.1,0.4-0.1,0.5C10,13.1,10.9,14,12,14z M21.2,17c-0.2,0.3-0.2,0.6-0.2,1c0,0,0,0.1,0,0.1
			c0,0.6,0.3,1.1,0.8,1.5c0.3,0.3,0.8,0.4,1.2,0.4c1.1,0,2-0.9,2-2c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.4c-0.2-0.9-1-1.5-1.9-1.5
			C22.2,16,21.6,16.4,21.2,17z M16.6,24c-0.1,0-0.2,0-0.3,0.1l0,0l0,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.2,0.2
			C15.3,24.8,15,25.4,15,26c0,0.1,0,0.2,0,0.2l0,0c0,0.2,0.1,0.4,0.2,0.6c0.2,0.4,0.5,0.7,0.9,0.9l0,0c0.2,0.1,0.4,0.2,0.7,0.2
			c0.6,0.1,1.1-0.1,1.6-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.3,0.2-0.5,0.2-0.8c0,0,0-0.1,0-0.1
			c0-0.6-0.3-1.1-0.8-1.5C17.9,24.2,17.5,24,17,24l0,0l0,0C16.9,24,16.7,24,16.6,24z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as LocalPaymentMethods
};
